// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hRI-","input":"styles_input__1JSyp"};